import {
  fetchPendingPointRequests,
  fetchProviderPointHistory,
} from "@/api/providerDashboard";
import sharedFormatters from "@shared/formatters.cjs";

const { formatLocalDateTimeToMinute: formatDate } = sharedFormatters;

export default {
  async fetchPending() {
    this.pendingLoading = true;
    try {
      const res = await fetchPendingPointRequests();
      if (res.data.status === 200) {
        this.pendingRequests = res.data.data;
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.pendingLoading = false;
    }
  },
  async fetchHistory() {
    this.historyLoading = true;
    try {
      const res = await fetchProviderPointHistory({
        page: this.historyPage,
        limit: 20,
      });
      if (res.data.status === 200) {
        this.historyItems = res.data.data;
        this.historyTotal = res.data.total;
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.historyLoading = false;
    }
  },
  formatDate,
};
